



import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const TestimonialsOne = () => {
const testimonials = [
  {
    image: "/images/resources/testi-2-1.jpg",
    name: "Mr.Amit Patil",
    role: "Corporate Client",
    review:
      "Aaradhya Travels provided excellent service for our corporate travel requirements. The vehicle was clean, the driver was punctual, and the entire journey was comfortable and hassle-free.",
  },
  {
    image: "/images/resources/testi-2-2.jpg",
    name: "Miss.Priya Sharma",
    role: "Family Traveler",
    review:
      "We booked a Tempo Traveller for our family vacation and had a wonderful experience. The vehicle was spacious, well-maintained, and the driver ensured a safe and pleasant journey.",
  },
  {
    image: "/images/resources/testi-2-3.jpg",
    name: "Mr.Rahul Deshmukh",
    role: "Business Executive",
    review:
      "The team at Aaradhya Travels delivered a professional and reliable travel experience. Their prompt service, comfortable vehicles, and courteous staff exceeded our expectations.",
  },
  {
    image: "/images/resources/testi-2-4.jpg",
    name: "Miss.Sneha Kulkarni",
    role: "Tourist",
    review:
      "Our group trip was perfectly organized by Aaradhya Travels. From timely pickup to comfortable transportation, every aspect of the journey was managed efficiently and professionally.",
  },
  {
    image: "/images/resources/testi-2-5.jpg",
    name: "Mr.Karan Joshi",
    role: "Event Organizer",
    review:
      "We hired multiple vehicles for an event and received outstanding service. The drivers were professional, the vehicles were clean, and everything was coordinated smoothly.",
  },
  {
    image: "/images/resources/testi-2-6.jpg",
    name: "Miss.Pooja Verma",
    role: "College Trip Coordinator",
    review:
      "Aaradhya Travels made our college trip comfortable and enjoyable. The bus was well-maintained, the service was excellent, and the entire journey was safe and convenient.",
  },
];

  return (
    <section className="testimonials-one section-" id="testimonial p-0 py-5">

      <div
        className="testimonials-one__bg"
        style={{
          backgroundImage:
            "url('/images/backgrounds/testimonials-bg-2-1.png')",
        }}
      />

      <div className="container">
        <div className="testimonials-one__top">
          <div className="sec-title sec-title--two text-start">
            <h6 className="sec-title__tagline">OUR TESTIMONIALS</h6>
            <h3 className="sec-title__title">
              what peoples say about <br /> Aaradhya Travels
            </h3>
          </div>
        </div>
      </div>

      {/* AUTO SLIDER */}
      <div className="container mt-4">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonials-card borderrr">

                {/* <div className="testimonials-card__top">
                  <img src={item.image} alt={item.name} />
                </div> */}

                <p className="testimonials-card__text text-white">
                  {item.review}
                </p>

                <div className="testimonials-card__content">
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialsOne;